import { useEffect } from 'react'

import { useInvoicingSettingsHost } from '../contexts/invoicingSettingsHostContext'
import type { InvoicingSettingsFormSave } from '../types/invoicingSettingsFormSave'

interface UseRegisterInvoicingSettingsFormProps {
  isDirty: boolean
  resetForm: () => void
  save: InvoicingSettingsFormSave
}

export const useRegisterInvoicingSettingsForm = ({
  isDirty,
  resetForm,
  save,
}: UseRegisterInvoicingSettingsFormProps) => {
  const { registerFormReset, registerFormSave, setIsDirty } = useInvoicingSettingsHost()

  useEffect(() => {
    setIsDirty(isDirty)
  }, [isDirty, setIsDirty])

  // The host cannot call RHF `reset()` itself because it does not know the form's fields. The form
  // registers the handler so the host can remap its dirty baseline after a successful Save.
  useEffect(() => {
    const unregisterFormReset = registerFormReset(resetForm)

    return unregisterFormReset
  }, [registerFormReset, resetForm])

  // Same reason for the save: only the form knows which endpoints its fields belong to.
  useEffect(() => {
    const unregisterFormSave = registerFormSave(save)

    return unregisterFormSave
  }, [registerFormSave, save])
}
